import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconRecommendedSvg } from "./IconRecommendedSvg.mjs";
const IconRecommended = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconRecommendedSvg, ...svgProps }) });
export {
  IconRecommended
};
